CustomBackgroundOptionsView = require 'app/scripts/views/board-menu/custom-background-options-view'
PopOver = require 'app/scripts/views/lib/pop-over'
SelectBackgroundView = require 'app/scripts/views/board-menu/select-background-view'
Util = require 'app/scripts/lib/util'

module.exports = class SelectCustomBackgroundView extends SelectBackgroundView
  initialize: ->
    super
    @listenTo @model, 'change:id', @render

  events:
    'click .js-options': 'openOptions'
    'click': 'selectBackground'

  openOptions: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-options')
      view: new CustomBackgroundOptionsView({ @model, @modelCache })

  getId: ->
    @model.id
